import React from 'react';
import i18n from 'i18next';
import { Navigate } from 'react-router';
import { AppRouteGroup } from 'app/store/components/NavigationUtils';

import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

const UsersDashboard = lazyRetry(() => import('./UsersDashboard'));

i18n.addResourceBundle('en', 'core', en);
i18n.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	routes: [
		{
			settings: {
				layout: {
					style: 'layout1',
					config: {
						mode: 'fullwidth',
						navbar: { display: false },
						toolbar: { display: false },
						footer: { display: false },
						leftSidePanel: { display: false },
						rightSidePanel: { display: false }
					}
				}
			},
			path: 'dashboard/:tabId/:pageId',
			element: <UsersDashboard />
		},
		{
			path: 'home',
			element: <Navigate to="/dashboard/user/home" replace />
		}
	]
};

export default routes;
